import { render } from "./PowerupsV3Modal.vue?vue&type=template&id=3ac259c2&scoped=true"
import script from "./PowerupsV3Modal.vue?vue&type=script&lang=js"
export * from "./PowerupsV3Modal.vue?vue&type=script&lang=js"

import "./PowerupsV3Modal.vue?vue&type=style&index=0&id=3ac259c2&scoped=true&lang=css"
import "./PowerupsV3Modal.vue?vue&type=style&index=1&id=3ac259c2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac259c2"]])

export default __exports__